/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { PutUsersPreferencesPipeSeriesOptions, PutUsersPreferencesPipeSeriesResponses } from '../types/PutUsersPreferencesPipeSeries'
import { client, withUnwrap } from '../.kubb/client'

/**
 * {@link /users/preferences/pipe-series/}
 */
export function putUsersPreferencesPipeSeries<ThrowOnError extends boolean = true>(options: Options<PutUsersPreferencesPipeSeriesOptions, ThrowOnError>): Unwrappable<RequestResult<PutUsersPreferencesPipeSeriesResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(request({ method: 'PUT', url: '/users/preferences/pipe-series/', security: [{ type: 'http', scheme: 'bearer' }], ...config, throwOnError: config.throwOnError ?? true }) as Promise<RequestResult<PutUsersPreferencesPipeSeriesResponses, ThrowOnError>>)
}
